import ModalDelete from './ModalDelete';

export default ModalDelete;
